import React from 'react';

export default ({options, placeholder, valueField = 'id', labelField = 'title', ...other}) => {
    return (
        <select
            className="dropdown field"
            {...other}
        >
            <option value="">{placeholder || 'Please select...'}</option>
            {!!options.length &&
            options.map(o => {
                return (
                    <option key={`option-${o[valueField]}`} value={o[valueField]}>
                        {o[labelField]}
                    </option>
                );
            })
            }
        </select>
    )
}
